// components/ElementCard.tsx
import React, { DragEvent } from 'react';
import styled from 'styled-components';
import { CreateFormTheme, Theme } from '../../utils/themes';
import { useTheme } from '../../middleware/ThemeContext';
import StyledText from '../StyledComponents/StyledText';
const CardContainer = styled.div<{ isDragging?: boolean, theme: Theme, isDarking: boolean }>`
  background: ${({ theme, isDarking }) => isDarking ? theme.CorporateTheme.colors.background : theme.CorporateTheme.colors.headerBG};
  border-radius: 4.48px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: grab;
  transition: all 0.2s;
  opacity: ${props => props.isDragging ? 0.5 : 1};
  
  &:hover {
    background: ${({ theme }) => theme.CorporateTheme.colors.headerBG};
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  
  &:active {
    cursor: grabbing;
  }
`;

const ElementIcon = styled.div`
  font-size: 24px;
  color: #6c63ff;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 6px;
`;

const ElementLabel = styled.span`
  font-size: 12px;
  color: #495057;
  font-weight: 500;
`;

const ElementBg = styled.div<{ theme: Theme; isDarking?: boolean }>`
  background:
    linear-gradient(180deg,  ${({ theme, isDarking }) => isDarking ? theme.CorporateTheme.colors.background : '#FFFFFF'} 0%, ${({ theme, isDarking }) => isDarking ? theme.CorporateTheme.colors.background : '#F5F5F5'} 100%) padding-box,
    linear-gradient(180deg, #DBD6D6 0%, ${({ theme, isDarking }) => isDarking ? theme.CorporateTheme.colors.background : '#F5F5F5'} 100%) border-box;
  width: 100%;
  height: 100%;
  border: 0.33px solid transparent;
  border-radius:5px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top:20px;
  text-align: center;
`

interface ElementCardProps {
  element: { type: string; label: string; icon: React.ReactNode };
  draggedElement: string | null;
  setDraggedElement: (element: string) => void;
  onDragEnd: () => void;
}

const ElementCard: React.FC<ElementCardProps> = ({
  element,
  draggedElement,
  setDraggedElement,
  onDragEnd
}) => {
  const isDarking = localStorage.getItem('appTheme') === 'dark';

  const { theme } = useTheme();
  const handleDragStart = (e: DragEvent<HTMLDivElement>) => {
    setDraggedElement(element.type);
    e.dataTransfer.effectAllowed = 'copy';
  };

  return (
    <CardContainer
      theme={theme}
      draggable
      onDragStart={handleDragStart}
      onDragEnd={onDragEnd}
      isDragging={draggedElement === element.type}
      isDarking={isDarking}
    >
      <ElementBg theme={theme} isDarking={isDarking}>
        <span>{element.icon}</span>
        <StyledText fontWeight={500} fontSize='14px' textColor={isDarking ? theme.CorporateTheme.colors.white : '#1E1E1E'}>{element.label}</StyledText>
      </ElementBg>
    </CardContainer>
  );
};

export default ElementCard;